import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import "./CareerBoosterSteps.css";

function CareerBoosterSteps() {
  const [activeStep, setActiveStep] = useState(3); // Defaulting to step 3 to match your reference image

  const stepsData = {
    1: {
      number: "01",
      title: "Complete your profile information",
      description:
        "Ensure your primary skills and past experiences are completely filled out to grab automatic tracking filters.",
    },
    2: {
      number: "02",
      title: "Activate recruiter keywords search",
      description:
        "Inject top keyword sets directly monitored by domain headhunters into your main bio lines.",
    },
    3: {
      number: "03",
      title: "Optimise your resume",
      description:
        "Switch to ATS-friendly format to enhance shortlist chances.",
    },
  };

  return (
    <div className="career-steps-parent-container">
      {/* Headings */}
      <h2 className="main-headline">Making the best of this service</h2>
      <p className="sub-paragraph">
        Go the extra mile! While the Career Booster gets to work boosting your
        profile, follow these steps to get noticed by recruiters
      </p>

      {/* Dynamic Content Frame */}
      <div className="steps-display-board">
        <Row className="align-items-center h-100">
          {/* Left Text Block */}
          <Col md={7} className="text-content-col">
            <div className="step-content-layout">
              <span className="big-step-number">
                {stepsData[activeStep].number}
              </span>
              <div className="step-text-wrapper">
                <h4 className="step-title-highlight">
                  {stepsData[activeStep].title}
                </h4>
                <p className="step-description">
                  {stepsData[activeStep].description}
                </p>
              </div>
            </div>
          </Col>

          {/* Right Vector Illustration Graphic Platform Simulation */}
          <Col md={5} className="illustration-display-col">
            <img
              src="/assets/Images/CareerBooster/howThingsWork.svg"
              className="how_to_work_img"
              alt="how_to_work"
            />
          </Col>
        </Row>
      </div>

      {/* Navigation Controls Row */}
      <div className="control-buttons-row">
        {[1, 2, 3].map((stepNum) => (
          <React.Fragment key={stepNum}>
            <button
              className={`btn-step-trigger ${activeStep === stepNum ? "active-trigger" : ""}`}
              onClick={() => setActiveStep(stepNum)}
            >
              Step {stepNum}
            </button>
            {stepNum < 3 && <span className="nav-chevron-divider">&gt;</span>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default CareerBoosterSteps;
